export default __webpack_public_path__ + "static/media/Tus cotizaciones.669e3c57.svg";